<style>
    .el-table .cell {
        text-align: left;
    }
</style>
<template>
    <el-table
    :data="data"
    border
    :max-height="config.height || 'auto'"
    :row-class-name="tableRowClassName"
    :style="{width: width}"
    v-loading.body="loading"
    @row-click="rowClick"
    @selection-change="handleSelectionChange">
        <!-- 多选框 start -->
        <el-table-column
            type="selection"
            width="35"
            v-if="config.isCheckbox">
        </el-table-column>
        <!-- 多选框 end -->
        <el-table-column
            type="index"
            align="center"
            width="35"
            v-if="config.isNumber">
        </el-table-column>
            <el-table-column
                v-for="(el, i) in head"
                :key="i"
                :label="el.label"
                :fixed="el.fixed"
                :width="el.width > 0 ? el.width : null"
                :sortable="el.sortable">
                    <template slot-scope="scope">
                        <!-- 数组类型 start -->
                        <template v-if="el.head && el.head.length > 0 && Array.isArray(scope.row[el.prop])">
                            <!-- 数据只有一条的时候 显示第一个字段的 -->
                           <!--  <template v-if="scope.row[el.prop] && scope.row[el.prop].length == 1">
                                {{scope.row[el.prop][0][el.head[0]['prop']]}}
                            </template> -->
                            <el-popover trigger="hover" placement="top" :ref="'popover' + scope.$index">
                                <el-table :data="scope.row[el.prop]" height="200">
                                    <template v-for="(item, key) in el.head">
                                        <el-table-column width="200" :prop="item.prop" :label="item.label" :key="'p0' + key"></el-table-column>
                                    </template>
                                </el-table>
                                <template slot='reference'>
                                    <div class="name-wrapper" v-if="scope.row[el.prop]" 
                                        @mouseenter="tagHover(scope.$index)"
                                        @mouseleave="tagLeave(scope.$index)">
                                        <el-tag v-if="scope.row[el.prop].length == 1">
                                        {{scope.row[el.prop][0][el.head[0]['prop']]}}
                                        </el-tag>
                                        <el-tag v-else>{{el.label}}({{scope.row[el.prop].length}})</el-tag>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                        <!-- 数组类型  end  -->
                        <!-- 普通一层数据获取 start -->
                        <template v-else>
                            <span v-html="scope.row[el.prop]"></span>
                        </template>
                        <!-- 普通一层数据获取 end -->
                    </template>
            </el-table-column>
        <el-table-column
            label="操作"
            :width="config.btnsWidth || 50"
            v-if="hasBtn">
            <template slot-scope="scope">
                <template v-if="buttons && buttons.length > 0">
                    <template v-for="(el, i) in buttons">
                        <template v-if="el.mark && el.mark === 'failure' && scope.row.status === '失效'">
                            --
                        </template>
                        <template v-else>
                            <el-button 
                                :key="i" 
                                :type="el.type" size="small"
                                v-if="el.mark && el.mark.length > 0"
                                @click="handleClick(el.mark, i, scope.row)">
                                {{el.text}}
                            </el-button>
                            <template v-else>
                                --
                            </template>
                        </template>
                    </template>
                </template>
                <template v-else>
                    --
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    /**
     * 基于element-ui中的Table二次封装 ，目的是能通过数据上的配置 灵活的现实不同列表内容的显示
     * @author zjs
     * @time 2017-06-08
     */
    export default {
        name: 'LyTable',
        props: {
            head: Array, // thead部分的数据配置
            data: Array, // tbody中的列表数据
            config: { // 表格的相关配置
                type: Object,
                default () {
                    return {
                        height: 0, // 表格的高度控制，如果不为0，列表内容超过高度时，表头固定 内容滚动
                        isCheckbox: false, // 是否显示多选框
                        isNumber: false, // 是否显示序号
                        btnsWidth: 100 // 操作列表的宽度配置，当buttons中有值时生效
                    }
                }
            },
            buttons: { // 操作按钮的配置
                type: Array,
                default () {
                    return []
                }
            },
            width: {
                type: String,
                default: '100%'
            },
            highlightedIndex: {
                type: [Number, String],
                default: ''
            }, // 当前高亮的行索引
            hasBtn: {
                type: Boolean,
                default: false
            }, // 标识，是否包含操作列
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            /**
             * 字段列表
             */
            fieldList () {
                let list = []
                for (let i in this.head) {
                    list.push(this.head[i]['prop'])
                }
                return list
            }
        },
        methods: {
            /**
             * 选中行时，高亮效果
             */
            tableRowClassName (row, index) {
                if (index === this.highlightedIndex) {
                    return 'info-row';
                } 
                return '';
            },
            /**
             * 操作按钮的事件监听
             * @param  {[String]} mark [按钮的标识]
             * @param  {[Number]} index [选中列的索引]
             * @param  {[Object]} row  [选中列的数据对象]
             */
            handleClick (mark, index, row) {
                this.$emit('click', mark, index, row)
            },
            /**
             * [多选框的选择事件监听]
             * @param  {[Array]} val [选中列的集合]
             */
            handleSelectionChange (val) {
                // 抛出事件
                this.$emit('change', val)
            },
            /**
             * 一行的数据被点击时
             */
            rowClick (row) {
                this.$emit('rowClick', row)
            },
            /**
             * 标签的hover监听
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            tagHover (index) {
                let popover = this.$refs['popover' + index]
                if (popover && popover.length > 0) {
                    popover[0].doShow()
                }
            },
            /**
             * tag移除监听，控制popover的隐藏
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            tagLeave (index) {
                let popover = this.$refs['popover' + index]
                if (popover && popover.length > 0) {
                    popover[0].doClose()
                }
            }
        }
    }
</script>